import { PageHeader, Skeleton } from '@estac1/ui';
import { ProductSection, RevenueSection, SmsSection } from './metrics/metrics-sections.js';
import { SmsCostSection } from './metrics/sms-cost-section.js';
import { SubscriptionsSection } from './metrics/subscriptions-section.js';
import { useMetrics } from './metrics/use-metrics.js';

export const MetricsScreen = () => {
  const { metrics, smsCost } = useMetrics();

  if (metrics.isLoading) {
    return (
      <div className="space-y-6">
        <PageHeader title="Métricas" description="Indicadores da plataforma." />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {['sk-1', 'sk-2', 'sk-3', 'sk-4', 'sk-5', 'sk-6', 'sk-7', 'sk-8'].map((id) => (
            <Skeleton key={id} className="h-24 w-full" />
          ))}
        </div>
      </div>
    );
  }

  if (metrics.isError || !metrics.data) {
    return (
      <div className="space-y-6">
        <PageHeader title="Métricas" description="Indicadores da plataforma." />
        <p className="text-sm text-muted-fg">
          Não foi possível carregar as métricas. Tente recarregar a página.
        </p>
      </div>
    );
  }

  const m = metrics.data;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Métricas"
        description="Indicadores da plataforma calculados a partir dos dados reais."
      />

      <SubscriptionsSection m={m} />
      <RevenueSection m={m} />
      <SmsSection m={m} />
      <ProductSection m={m} />
      <SmsCostSection smsCost={smsCost} />
    </div>
  );
};
